import React, { useEffect, useState } from "react";
import TrackingTimeline from "./TrackingTimeline";
import axios from "axios";

export default function TrackingModal({ isOpen, onClose, item }) {

    const apiUrl = process.env.REACT_APP_API_BASE_URL;
    const [events, setEvents] = useState([]);
    const [loadingEvents, setLoadingEvents] = useState(false);
    const [eventsError, setEventsError] = useState(null);

    useEffect(() => {
        const fetchTrackingDetails = async () => {
            if (!isOpen) {
                setEvents([]);
                return;
            }

            setLoadingEvents(true);
            setEventsError(null);

            try {
                const { data } = await axios.get(`${apiUrl}search/details`, {
                    params: {
                        enquiryId: item.enquiryId,
                        orderId: item.orderId,
                        sourceChannel: item.sourceChannel,
                    },
                });

                if (Array.isArray(data?.successList)) {
                    setEvents(data.successList);
                } else {
                    setEvents([]);
                    setEventsError("No tracking information available.");
                }
            } catch (error) {
                console.error("Failed to fetch tracking details", error);
                setEventsError("Failed to load tracking information.");
                setEvents([]);
            } finally {
                setLoadingEvents(false);
            }
        };

        fetchTrackingDetails();
    }, [isOpen, item]);

    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center p-2 sm:p-5 z-[9999]">
            <div className="w-full sm:w-[70%] max-w-[800px] max-h-[85vh] bg-white rounded-cb-md p-4 sm:p-6 overflow-y-auto relative shadow-xl">
                {/* CLOSE BUTTON */}
                <button
                    onClick={onClose}
                    className="absolute top-3 right-3 bg-gray-100 hover:bg-gray-200 border border-transparent px-3 py-1.5 rounded-md text-sm font-semibold text-gray-700"
                >
                    ✕
                </button>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-2 mt-6">
                    {/* LEFT SIDE — Details */}
                    <div>
                        <h2 className="text-lg font-semibold mb-2 text-[#1d2f5b]">Customer Details</h2>
                        <div className="text-sm text-gray-700"><span className="text-gray-500">Name:</span> {item?.name || "—"}</div>
                        <div className="text-sm text-gray-700"><span className="text-gray-500">Contact:</span> {item?.mobile || "—"}</div>
                        <div className="text-sm text-gray-700"><span className="text-gray-500">Code:</span> {item?.customerId || "—"}</div>

                        <h2 className="text-lg font-semibold mt-5 text-[#1d2f5b]">Order Details</h2>
                        <div className="text-sm text-gray-700"><span className="text-gray-500">Enquiry ID:</span> {item?.enquiryId || "—"}</div>
                        <div className="text-sm text-gray-700"><span className="text-gray-500">Order ID:</span> {item?.orderId || "—"}</div>

                        <h3 className="text-base font-semibold mt-5 text-[#1d2f5b]">Delivery Address</h3>
                        <div className="text-sm text-gray-700">{item?.address || "—"}</div>

                        <h3 className="text-base font-semibold mt-5 text-[#1d2f5b]">Warehouse Details</h3>
                        <div className="text-sm text-gray-700">{item?.warehouseAddress || "—"}</div>
                    </div>

                    {/* RIGHT SIDE — Tracking */}
                    <div>
                        {loadingEvents && (
                            <div className="text-sm text-gray-500">Loading tracking timeline…</div>
                        )}
                        {!loadingEvents && eventsError && (
                            <div className="text-sm text-red-500">{eventsError}</div>
                        )}
                        {!loadingEvents && !eventsError && events.length === 0 && (
                            <div className="text-sm text-gray-500">No tracking events to display.</div>
                        )}
                        {!loadingEvents && events.length > 0 && (
                            <TrackingTimeline events={events} />
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
}
